import { SET_BASIC_NLP_TAB } from './types'

export function setBasicNLPTab(tab: "schema" | "data") {
  return {
    type: SET_BASIC_NLP_TAB,
    data: tab,
  }
}
